{
  "name": "Fey ci jëlëg",
  "description": "Fey ci xaalis bu ñu la indil sa komand",
  "eligibility": {
    "eligible": "Fey ci jëlëg mën na am",
    "not_eligible": "Fey ci jëlëg amul",
    "min_amount": "Tollu bu gën a ndaw : {{amount}} FCFA",
    "max_amount": "Tollu bu gën a mag : {{amount}} FCFA",
    "zone_restricted": "Amul ci sa zone indil",
    "max_pending": "Jàpp nga komand yi ci xaar yu bari naa"
  },
  "verification": {
    "title": "Dëggal nimero bi",
    "subtitle": "Dinu la yonnee code ci SMS",
    "enter_code": "Duggal code bi nga jot ci SMS",
    "resend": "Yonnee code bi kenn",
    "resend_countdown": "Yonnee ci {{seconds}}s",
    "verified": "Nimero bi dëgg na",
    "invalid_code": "Code bi baaxul",
    "expired": "Code bi jeex na, ñaaneel benn bu bees"
  },
  "confirmation": {
    "title": "Komand bi dëgg na — Fey ci jëlëg",
    "amount_due": "Tollu bu war fey : {{amount}} FCFA",
    "instructions": "Teyaaral xaalis bi baax-baax ngir livreur bi",
    "no_change": "Livreur bi delluñu xaalis"
  },
  "admin": {
    "title": "Parameetar fey ci jëlëg",
    "enabled": "Teral fey ci jëlëg",
    "min_amount": "Tollu bu gën a ndaw (FCFA)",
    "max_amount": "Tollu bu gën a mag (FCFA)",
    "zones": "Zone yi nangu",
    "phone_verification": "Dëggal nimero telefon war na am",
    "max_pending": "Limu komand ci xaar bu gën a bari ci kiliyaan",
    "save": "Denc"
  }
}
